import { Map } from 'immutable';
import { ApiResponseHelper } from 'omni-common-ui';

import {
  FETCH_SCORE_BAND_SUCCESS,
  FETCH_SCORE_BAND_FAILURE,
} from './actions';
import ScoreBand from './model';

export default function scoreBandReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_SCORE_BAND_SUCCESS:
      return addScoreBandToMap(state, action);
    case FETCH_SCORE_BAND_FAILURE:
      return state.set(`${action.score}-${action.languageCode}`,
          ApiResponseHelper.create(action.error));
    default:
      return state;
  }
}

function addScoreBandToMap(state, { payload }) {
  let newState = state;
  if (payload && payload.length && payload.length !== 0) {
    payload.forEach((scoreBand) => {
      const model = new ScoreBand(scoreBand);
      newState = newState.set(model.id, model);
    });
  }
  return newState;
}



// WEBPACK FOOTER //
// ./data/ScoreBand/reducer.js